import { Card, IconButton, Table } from '@mui/joy';
import { useEffect, useState } from 'react';
import { RecentRound } from '../models/recent-round';
import { recentRoundsService } from '../services/recent-rounds-service';
import { listAccountRounds } from '../services/account-service';
import { useAuth } from '../auth/AuthContext';
import { useNavigate } from 'react-router';
import LaunchIcon from '@mui/icons-material/Launch';

const mergeRounds = (local: RecentRound[], server: RecentRound[]): RecentRound[] => {
    const merged = [...local];
    const seenRoundIds = new Set(local.map((r) => r.roundId));
    for (const round of server) {
        if (seenRoundIds.has(round.roundId)) continue;
        seenRoundIds.add(round.roundId);
        merged.push(round);
    }
    return merged;
};

const RecentRounds = () => {
    const { playerId } = useAuth();
    const [recentRounds, setRecentRounds] = useState<RecentRound[]>([]);

    useEffect(() => {
        const localRounds = recentRoundsService.getRecentRounds();
        setRecentRounds(localRounds);

        if (!playerId) return;

        listAccountRounds()
            .then((accountRounds) => {
                const serverRounds: RecentRound[] = accountRounds.map((r) => ({
                    roundId: r.roundId,
                    roundName: r.roundName,
                    roundDate: r.roundDate,
                    playerId: r.playerId,
                    playerName: r.playerName,
                }));
                setRecentRounds(mergeRounds(localRounds, serverRounds));
            })
            .catch(() => {
                // Fail open — keep showing the local list if the account rounds call errors.
            });
    }, [playerId]);

    const navigate = useNavigate();

    const openRound = (roundId: string, playerId: string) => {
        navigate(`/${roundId}/${playerId}`);
    };

    return (
        <Card variant="outlined">
            <Table>
                <thead>
                    <tr>
                        <th style={{ width: '40%' }}>Round</th>
                        <th style={{ width: '25%' }}>Date</th>
                        <th style={{ width: '25%' }}>Player</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {recentRounds.map((round) => (
                        <tr key={round.roundId + '/' + round.playerId}>
                            <td>{round.roundName}</td>
                            <td>
                                {round.roundDate ? new Date(round.roundDate + 'T00:00:00').toLocaleDateString() : ''}
                            </td>
                            <td>{round.playerName}</td>
                            <td>
                                <IconButton
                                    aria-label={`Open round ${round.roundName}`}
                                    onClick={() => openRound(round.roundId, round.playerId)}
                                >
                                    <LaunchIcon />
                                </IconButton>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Card>
    );
};

export default RecentRounds;
